(function () {
  function getProductHandle(card) {
    if (!card) {
      return "";
    }

    const dataHandle = card.getAttribute("data-product-handle");

    if (dataHandle) {
      return dataHandle;
    }

    const productLink = card.querySelector('a[href*="/products/"]');

    if (!productLink) {
      return "";
    }

    const href = productLink.getAttribute("href") || "";
    const match = href.match(/\/products\/([^/?#]+)/);

    return match ? match[1] : "";
  }

  function getBestSellerCount(section) {
    const count = parseInt(section.getAttribute("data-best-seller-count") || "3", 10);
    return Number.isFinite(count) && count > 0 ? count : 3;
  }

  function getBestSellingUrl() {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", "best-selling");
    return url.toString();
  }

  function collectTopHandles(source, section, count) {
    const matchingSection = section.id ? source.getElementById(section.id) : null;
    const searchRoot = matchingSection || source.querySelector(".cookie-collection") || source;
    const handles = [];
    const seenHandles = new Set();
    const cards = searchRoot.querySelectorAll(".e");

    cards.forEach(function (card) {
      if (handles.length >= count) {
        return;
      }

      const handle = getProductHandle(card);

      if (handle && !seenHandles.has(handle)) {
        seenHandles.add(handle);
        handles.push(handle);
      }
    });

    return handles;
  }

  function markBestSellers(section, handles) {
    const currentCards = Array.from(section.querySelectorAll(".e"));

    handles.forEach(function (handle) {
      const card = currentCards.find(function (currentCard) {
        return getProductHandle(currentCard) === handle;
      });

      if (!card) {
        return;
      }

      let badge = card.querySelector(".best-seller-badge");
      const box = card.querySelector(".cookiebox");
      const imageContainer = card.querySelector(".rollover, .cookiebox2");

      if (!badge && imageContainer) {
        badge = document.createElement("span");
        badge.className = "best-seller-badge";
        badge.textContent = "Best Seller";
        imageContainer.appendChild(badge);
      }

      if (badge) {
        badge.hidden = false;
        badge.removeAttribute("hidden");
        badge.textContent = "Best Seller";
      }

      if (box) {
        box.classList.add("has-best-seller-badge");
      }
    });
  }

  async function initBestSellerBadges() {
    let sections = document.querySelectorAll('.cookie-collection[data-best-seller-badges="true"]');

    if (!sections.length) {
      sections = document.querySelectorAll(".cookie-collection");
    }

    if (!sections.length) {
      return;
    }

    try {
      const response = await fetch(getBestSellingUrl(), { credentials: "same-origin" });

      if (!response.ok) {
        return;
      }

      const html = await response.text();
      const parsedDocument = new DOMParser().parseFromString(html, "text/html");

      sections.forEach(function (section) {
        const handles = collectTopHandles(parsedDocument, section, getBestSellerCount(section));
        markBestSellers(section, handles);
      });

      window.cookieBestSellerBadgesStatus = {
        loaded: true,
        sectionCount: sections.length,
        bestSellingUrl: getBestSellingUrl()
      };
    } catch (error) {
      window.cookieBestSellerBadgesStatus = {
        loaded: false,
        error: error && error.message ? error.message : String(error)
      };
      return;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBestSellerBadges);
  } else {
    initBestSellerBadges();
  }
})();
